/**
 * Deterministic Pseudo-Random Number Generator (XORShift32)
 * Initialized with master seed 0xDEADBEEF for cross-platform physics replication.
 */

export class PRNG {
  private state: number;

  constructor(seed = 0xDEADBEEF) {
    this.state = seed >>> 0;
  }

  /**
   * Returns a pseudo-random 32-bit unsigned integer
   */
  public nextUint32(): number {
    let x = this.state;
    x ^= x << 13;
    x ^= x >>> 17;
    x ^= x << 5;
    this.state = x >>> 0;
    return this.state;
  }

  /**
   * Returns a pseudo-random float in range [0, 1)
   */
  public nextFloat(): number {
    return this.nextUint32() / 4294967296.0;
  }

  /**
   * Returns a pseudo-random float in range [min, max)
   */
  public range(min: number, max: number): number {
    return min + this.nextFloat() * (max - min);
  }

  /**
   * Resets PRNG state back to given or default seed
   */
  public reseed(seed = 0xDEADBEEF): void {
    this.state = seed >>> 0;
  }
}

export const globalPRNG = new PRNG(0xDEADBEEF);
